import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionUpdateComponent } from '../components/modals/version-update/version-update.component';

@Injectable()
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
  private isModalOpen = false; // Prevent multiple modals

  constructor(
    private http: HttpClient,
    private modalService: NgbModal
  ) { }

  public initVersionCheck(
    frequency = 60 * 60 * 1000, // Default 1 hour
    //frequency = 5 * 1000, // Default 30 minutes
  ) {
    this.checkVersion('./version.json');
    
    setInterval(() => {
      this.checkVersion('./version.json');
    }, frequency);
  }

  private checkVersion(url: string) {
    this.http.get(url + '?t=' + new Date().getTime()).subscribe(
      (response: any) => {
        console.log('Version check response:', response);
        const hash = response.hash;
        const hashChanged = this.hasHashChanged(this.currentHash, hash);

        if (hashChanged && !this.isModalOpen) {
          this.showUpdateModal();
        }
        this.currentHash = hash;
      },
      (err) => {
        console.error(err, 'Could not get version');
      },
    );
  }

  private showUpdateModal() {
    this.isModalOpen = true;

    const modalRef = this.modalService.open(VersionUpdateComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'md'
    });

    modalRef.result.then(
      (result) => {
        this.isModalOpen = false;
      },
      (dismissed) => {
        this.isModalOpen = false;
        // If user dismisses, check again in 60 minutes
        setTimeout(() => {
          this.checkVersion('./version.json');
        }, 60 * 60 * 1000);
      },
    );
  }

  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }
}
